webpackJsonp([13],{

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_inputs_app_input__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_inputs_text_area__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(19);




var reclamationAction = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var ecommerceLocal, body, url;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						ecommerceLocal = this.getLocalStorage('ecommerce::ecommerce-data');
						body = this.reclamation;

						body.subsidiaryId = ecommerceLocal.subsidiaryId;
						url = 'claim-book';
						_context.prev = 4;
						_context.next = 7;
						return this.$httpSales.post(url, body);

					case 7:
						this.showNotification('Su reclamo ha sido registrado', 'success');
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](4);

						this.showGenericError();

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 10]]);
	}));

	return function reclamationAction() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function mounted() {
	this.setCommerceData();
}

function setCommerceData() {
	var _getCommerceData = this.getCommerceData,
	    address = _getCommerceData.address,
	    documentNumber = _getCommerceData.documentNumber,
	    id = _getCommerceData.id,
	    rzSocial = _getCommerceData.rzSocial,
	    code = _getCommerceData.code;

	this.reclamation.commerceAddress = address;
	this.reclamation.commerceCode = code;
	this.reclamation.commerceName = rzSocial;
	this.reclamation.commereRuc = documentNumber;
	this.reclamation.commerceId = id;
}

function getCommerceData() {
	this.setCommerceData();
}

function reclamo(_ref) {
	var target = _ref.target;

	this.reclamation.orderClaimDetail = Number(target.value);
}

function typesGood(_ref2) {
	var target = _ref2.target;

	this.reclamation.claimentWellHired.product = target.value === 'product';
	this.reclamation.claimentWellHired.services = target.value === 'services';
}

function validations() {
	var _this = this;

	return {
		reclamation: {
			// answerDate: { required },
			// answerDescription: { required },
			claimDetail: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimDate: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimOrder: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimentAddress: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimentDocument: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimentEmail: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
			claimentName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimetPhone: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			claimentWellHired: {
				product: {
					required: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["requiredIf"])(function () {
						var services = _this.reclamation.claimentWellHired.services;

						return services === false || services === null;
					})
				},
				services: {
					required: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["requiredIf"])(function () {
						var product = _this.reclamation.claimentWellHired.product;

						return product === false || product === null;
					})
				},
				amountClaiment: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(1) },
				description: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
			},
			commerceAddress: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			commerceCode: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			commerceId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(1) },
			commerceName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			commereRuc: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			orderClaimDetail: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], minValue: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minValue"])(1) }
		}
	};
}

function data() {
	return {
		reclamation: {
			// answerDate: '',
			// answerDescription: '',
			claimDetail: '',
			claimDate: '',
			claimOrder: '',
			claimentAddress: '',
			claimentDocument: '',
			claimentEmail: '',
			claimentName: '',
			claimetPhone: '',
			claimentWellHired: {
				product: null,
				services: null,
				amountClaiment: 0,
				description: ''
			},
			commerceAddress: '',
			commerceCode: '',
			commerceId: 0,
			commerceName: '',
			commereRuc: '',
			orderClaimDetail: 0
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-reclamaciones',
	components: {
		appInput: __WEBPACK_IMPORTED_MODULE_4__components_shared_inputs_app_input__["a" /* default */],
		textArea: __WEBPACK_IMPORTED_MODULE_5__components_shared_inputs_text_area__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['getCommerceData']), {
		emailError: function emailError() {
			return this.reclamation.claimentEmail && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.reclamation.claimentEmail);
		}
	}),
	data: data,
	methods: {
		reclamo: reclamo,
		typesGood: typesGood,
		reclamationAction: reclamationAction,
		setCommerceData: setCommerceData
	},
	mounted: mounted,
	validations: validations,
	watch: {
		getCommerceData: getCommerceData
	}
});

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1445);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(784)("e00f2b2c", content, true, {});

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(783)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.reclamations-container[data-v-005f345a]{margin:auto;padding-top:20px;width:500px}.reclamations-container .main-title[data-v-005f345a]{margin-bottom:15px;text-align:center}.reclamations-container .section[data-v-005f345a]{margin:10px 0}.reclamations-container .input[data-v-005f345a]{margin-bottom:15px;text-align:left;width:100%}.reclamations-container .radio[data-v-005f345a]{margin:10px 0}.reclamations-container .radio[data-v-005f345a]:last-child{margin-right:40px}.reclamations-container .consumer-order[data-v-005f345a]{margin:10px 0}.reclamations-container .sign[data-v-005f345a]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;height:80px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.reclamations-container .send-reclamation[data-v-005f345a]{color:#fff;font-family:Avenir Next Bold;height:50px;width:100%}.reclamations-container .send-reclamation[disabled][data-v-005f345a]{cursor:not-allowed;opacity:.3}.flex[data-v-005f345a]{display:-webkit-box;display:-ms-flexbox;display:flex}.items-center[data-v-005f345a]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.justify-center[data-v-005f345a]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.text-center[data-v-005f345a]{text-align:center}.flex50[data-v-005f345a]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}.col[data-v-005f345a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.w-full[data-v-005f345a]{width:100%}.error-message[data-v-005f345a]{color:red;font-size:12px;margin-top:5px}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-reclamaciones.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,yCACE,YAAa,AACb,iBAAkB,AAClB,WAAa,CACd,AACD,qDACI,mBAAoB,AACpB,iBAAmB,CACtB,AACD,kDACI,aAAe,CAClB,AACD,gDACI,mBAAoB,AACpB,gBAAiB,AACjB,UAAY,CACf,AACD,gDACI,aAAe,CAClB,AACD,2DACM,iBAAmB,CACxB,AACD,yDACI,aAAe,CAClB,AACD,+CACI,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,UAAY,CACf,AACD,2DACI,WAAa,AACb,6BAAgC,AAChC,YAAa,AACb,UAAY,CACf,AACD,qEACI,mBAAoB,AACpB,UAAa,CAChB,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,iCACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,8BACE,iBAAmB,CACpB,AACD,yBACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,sBACE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,yBACE,UAAY,CACb,AACD,gCACE,UAAW,AACX,eAAgB,AAChB,cAAgB,CACjB","file":"page-reclamaciones.vue","sourcesContent":["\n@font-face {\n  font-family: \"Avenir Next Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Demi Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Book\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n.reclamations-container[data-v-005f345a] {\n  margin: auto;\n  padding-top: 20px;\n  width: 500px;\n}\n.reclamations-container .main-title[data-v-005f345a] {\n    margin-bottom: 15px;\n    text-align: center;\n}\n.reclamations-container .section[data-v-005f345a] {\n    margin: 10px 0;\n}\n.reclamations-container .input[data-v-005f345a] {\n    margin-bottom: 15px;\n    text-align: left;\n    width: 100%;\n}\n.reclamations-container .radio[data-v-005f345a] {\n    margin: 10px 0;\n}\n.reclamations-container .radio[data-v-005f345a]:last-child {\n      margin-right: 40px;\n}\n.reclamations-container .consumer-order[data-v-005f345a] {\n    margin: 10px 0;\n}\n.reclamations-container .sign[data-v-005f345a] {\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 80px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 100%;\n}\n.reclamations-container .send-reclamation[data-v-005f345a] {\n    color: white;\n    font-family: \"Avenir Next Bold\";\n    height: 50px;\n    width: 100%;\n}\n.reclamations-container .send-reclamation[disabled][data-v-005f345a] {\n    cursor: not-allowed;\n    opacity: 0.3;\n}\n.flex[data-v-005f345a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.items-center[data-v-005f345a] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.justify-center[data-v-005f345a] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.text-center[data-v-005f345a] {\n  text-align: center;\n}\n.flex50[data-v-005f345a] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 50%;\n          flex: 1 1 50%;\n}\n.col[data-v-005f345a] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.w-full[data-v-005f345a] {\n  width: 100%;\n}\n.error-message[data-v-005f345a] {\n  color: red;\n  font-size: 12px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reclamations-container"},[_c('h2',{staticClass:"main-title"},[_vm._v("Libro de reclamaciones")]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h3',[_vm._v("Razón social: "+_vm._s(_vm.getCommerceData.rzSocial))]),_vm._v(" "),_c('h3',[_vm._v("RUC: "+_vm._s(_vm.getCommerceData.documentNumber))])]),_vm._v(" "),_c('form',[_c('div',{staticClass:"section"},[_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tFecha\n\t\t\t\t"),_c('app-input',{attrs:{"type":"date","placeholder":"Fecha"},model:{value:(_vm.reclamation.claimDate),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimDate", $$v)},expression:"reclamation.claimDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h4',[_vm._v("1. Identificación del consumidor reclamante")]),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tNombre\n\t\t\t\t"),_c('app-input',{attrs:{"type":"text","placeholder":"Nombre"},model:{value:(_vm.reclamation.claimentName),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimentName", $$v)},expression:"reclamation.claimentName"}})],1),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tDomicilio\n\t\t\t\t"),_c('app-input',{attrs:{"type":"text","placeholder":"Domicilio"},model:{value:(_vm.reclamation.claimentAddress),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimentAddress", $$v)},expression:"reclamation.claimentAddress"}})],1),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tDocumento de identidad\n\t\t\t\t"),_c('app-input',{attrs:{"type":"text","placeholder":"Documento Identidad (DNI, CE)"},model:{value:(_vm.reclamation.claimentDocument),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimentDocument", $$v)},expression:"reclamation.claimentDocument"}})],1),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tTeléfono o celular\n\t\t\t\t"),_c('app-input',{attrs:{"type":"tel","placeholder":"Teléfono"},model:{value:(_vm.reclamation.claimetPhone),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimetPhone", $$v)},expression:"reclamation.claimetPhone"}})],1),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tCorreo electrónico\n\t\t\t\t"),_c('app-input',{attrs:{"type":"email","placeholder":"Correo"},model:{value:(_vm.reclamation.claimentEmail),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimentEmail", $$v)},expression:"reclamation.claimentEmail"}})],1),_vm._v(" "),(_vm.emailError)?_c('span',{staticClass:"error-message"},[_vm._v("Por favor, ingresa un correo electrónico válido.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h4',[_vm._v("2. Identificación del bien contratado")]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"product"}},[_vm._v("\n\t\t\t\t\tProducto\n\t\t\t\t\t"),_c('input',{staticClass:"radio",attrs:{"type":"radio","name":"product","id":"product","value":"product"},on:{"input":_vm.typesGood}})]),_vm._v(" "),_c('label',{attrs:{"for":"services"}},[_vm._v("\n\t\t\t\t\tServicios\n\t\t\t\t\t"),_c('input',{staticClass:"radio",attrs:{"type":"radio","name":"product","id":"services","value":"services"},on:{"input":_vm.typesGood}})])]),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tMonto reclamado\n\t\t\t\t"),_c('app-input',{attrs:{"type":"text","placeholder":"Monto reclamado"},model:{value:(_vm.reclamation.claimentWellHired.amountClaiment),callback:function ($$v) {_vm.$set(_vm.reclamation.claimentWellHired, "amountClaiment", $$v)},expression:"reclamation.claimentWellHired.amountClaiment"}})],1),_vm._v(" "),_c('label',{staticClass:"input"},[_vm._v("\n\t\t\t\tDescripción\n\t\t\t\t"),_c('text-area',{attrs:{"rows":"5","placeholder":"Descripción"},model:{value:(_vm.reclamation.claimentWellHired.description),callback:function ($$v) {_vm.$set(_vm.reclamation.claimentWellHired, "description", $$v)},expression:"reclamation.claimentWellHired.description"}})],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('h4',[_vm._v("3. Detalle de la reclamación y pedido del consumidor")]),_vm._v(" "),_c('label',{attrs:{"for":"reclamo"}},[_vm._v("\n\t\t\t\tReclamo\n\t\t\t\t"),_c('input',{staticClass:"radio",attrs:{"type":"radio","name":"reclamacion","id":"reclamo"},domProps:{"value":1},on:{"input":_vm.reclamo}})]),_vm._v(" "),_c('label',{attrs:{"for":"queja"}},[_vm._v("\n\t\t\t\tQueja\n\t\t\t\t"),_c('input',{staticClass:"radio",attrs:{"type":"radio","name":"reclamacion","id":"queja"},domProps:{"value":2},on:{"input":_vm.reclamo}})]),_vm._v(" "),_c('text-area',{attrs:{"rows":"5","placeholder":"Detalle"},model:{value:(_vm.reclamation.claimDetail),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimDetail", $$v)},expression:"reclamation.claimDetail"}}),_vm._v(" "),_c('text-area',{staticClass:"consumer-order",attrs:{"rows":"5","placeholder":"Pedido"},model:{value:(_vm.reclamation.claimOrder),callback:function ($$v) {_vm.$set(_vm.reclamation, "claimOrder", $$v)},expression:"reclamation.claimOrder"}})],1),_vm._v(" "),_c('button',{staticClass:"send-reclamation",style:(("background-color:" + (_vm.globalColors.primary))),attrs:{"type":"button","disabled":_vm.$v.$invalid},on:{"click":_vm.reclamationAction}},[_vm._v("\n\t\t\tEnviar Reclamación\n\t\t")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('b',[_vm._v("*RECLAMO:")]),_vm._v(" Disconformidad relacionada a los productos o\n\t\tservicios.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('b',[_vm._v("*QUEJA:")]),_vm._v(" Disconformidad no relacionada a los productos o servicios;\n\t\to malestar o descontento respecto a la atención al público.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_reclamaciones_vue__ = __webpack_require__(1104);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005f345a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_reclamaciones_vue__ = __webpack_require__(1446);
function injectStyle (ssrContext) {
  __webpack_require__(1444)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-005f345a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_reclamaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_005f345a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_reclamaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(831));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendValue(_ref) {
	var target = _ref.target;

	this.$emit('input', target.value);
}

function blurValue(_ref2) {
	var target = _ref2.target;

	this.$emit('blur', target.value);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-input',
	inheritAttrs: false,
	methods: {
		blurValue: blurValue,
		sendValue: sendValue
	},
	props: {
		borderColor: {
			default: '#e6e6e6',
			type: String
		},
		value: null
	}
});

/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_input_vue__ = __webpack_require__(819);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06758668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_input_vue__ = __webpack_require__(823);
function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06758668"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06758668_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(822);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(784)("10cbb76c", content, true, {});

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(783)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}.input-container[data-v-06758668]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.app-input[data-v-06758668]{background-color:#fcfcfc;border:1px solid #e6e6e6;border-radius:7px;color:#acaaaa;font-family:Avenir Next Medium;font-size:14px;height:46.8px;outline:none;padding:0 16.2px;width:100%}input.app-input[data-v-06758668]::-webkit-input-placeholder{color:#e6e6e6;font-family:Avenir Next Demi;font-size:13px}.app-input[data-v-06758668]::-webkit-input-placeholder{color:#e6e6e6;font-family:Avenir Next Demi!important;font-size:13px!important;font-weight:400!important}.app-input[data-v-06758668]::-moz-placeholder{color:#e6e6e6;font-family:Avenir Next Demi!important;font-size:13px!important;font-weight:400!important}.app-input[data-v-06758668]::-ms-input-placeholder{color:#e6e6e6;font-family:Avenir Next Demi!important;font-size:13px!important;font-weight:400!important}.app-input[data-v-06758668]::placeholder{color:#e6e6e6;font-family:Avenir Next Demi!important;font-size:13px!important;font-weight:400!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/inputs/app-input.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,4BACE,yBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,+BAAkC,AAClC,eAAgB,AAChB,cAAe,AACf,aAAc,AACd,iBAAoB,AACpB,UAAY,CACb,AACD,4DACE,cAAe,AACf,6BAAgC,AAChC,cAAgB,CACjB,AACD,uDACE,cAAe,AACf,uCAA2C,AAC3C,yBAA2B,AAC3B,yBAA+B,CAChC,AACD,8CACE,cAAe,AACf,uCAA2C,AAC3C,yBAA2B,AAC3B,yBAA+B,CAChC,AACD,mDACE,cAAe,AACf,uCAA2C,AAC3C,yBAA2B,AAC3B,yBAA+B,CAChC,AACD,yCACE,cAAe,AACf,uCAA2C,AAC3C,yBAA2B,AAC3B,yBAA+B,CAChC","file":"app-input.vue","sourcesContent":["\n@font-face {\n  font-family: \"Avenir Next Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Demi Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Book\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n.input-container[data-v-06758668] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.app-input[data-v-06758668] {\n  background-color: #fcfcfc;\n  border: 1px solid #e6e6e6;\n  border-radius: 7px;\n  color: #acaaaa;\n  font-family: \"Avenir Next Medium\";\n  font-size: 14px;\n  height: 46.8px;\n  outline: none;\n  padding: 0px 16.2px;\n  width: 100%;\n}\ninput.app-input[data-v-06758668]::-webkit-input-placeholder {\n  color: #e6e6e6;\n  font-family: \"Avenir Next Demi\";\n  font-size: 13px;\n}\n.app-input[data-v-06758668]::-webkit-input-placeholder {\n  color: #e6e6e6;\n  font-family: \"Avenir Next Demi\" !important;\n  font-size: 13px !important;\n  font-weight: normal !important;\n}\n.app-input[data-v-06758668]::-moz-placeholder {\n  color: #e6e6e6;\n  font-family: \"Avenir Next Demi\" !important;\n  font-size: 13px !important;\n  font-weight: normal !important;\n}\n.app-input[data-v-06758668]::-ms-input-placeholder {\n  color: #e6e6e6;\n  font-family: \"Avenir Next Demi\" !important;\n  font-size: 13px !important;\n  font-weight: normal !important;\n}\n.app-input[data-v-06758668]::placeholder {\n  color: #e6e6e6;\n  font-family: \"Avenir Next Demi\" !important;\n  font-size: 13px !important;\n  font-weight: normal !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('input',_vm._b({staticClass:"app-input",style:(("border-color: " + _vm.borderColor)),domProps:{"value":_vm.value},on:{"input":_vm.sendValue,"blur":_vm.blurValue}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"err-message"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(830));

var _alphaNum = _interopRequireDefault(__webpack_require__(833));

var _numeric = _interopRequireDefault(__webpack_require__(834));

var _between = _interopRequireDefault(__webpack_require__(835));

var _email = _interopRequireDefault(__webpack_require__(836));

var _ipAddress = _interopRequireDefault(__webpack_require__(837));

var _macAddress = _interopRequireDefault(__webpack_require__(838));

var _maxLength = _interopRequireDefault(__webpack_require__(839));

var _minLength = _interopRequireDefault(__webpack_require__(840));

var _required = _interopRequireDefault(__webpack_require__(841));

var _requiredIf = _interopRequireDefault(__webpack_require__(842));

var _requiredUnless = _interopRequireDefault(__webpack_require__(843));

var _sameAs = _interopRequireDefault(__webpack_require__(844));

var _url = _interopRequireDefault(__webpack_require__(845));

var _or = _interopRequireDefault(__webpack_require__(846));

var _and = _interopRequireDefault(__webpack_require__(847));

var _not = _interopRequireDefault(__webpack_require__(848));

var _minValue = _interopRequireDefault(__webpack_require__(849));

var _maxValue = _interopRequireDefault(__webpack_require__(850));

var _integer = _interopRequireDefault(__webpack_require__(851));

var _decimal = _interopRequireDefault(__webpack_require__(852));

var helpers = _interopRequireWildcard(__webpack_require__(818));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","ACL_COMPANY_CODE":'ca01',"ACL_URL":'https://acl.apprunn.net/api',"APP_CODE":'ecommerce',"APP_NAME":'undefined',"CLIENT_ID":'',"CODE_PROJECT":'maki_project',"COLOR_PRIMARY":'undefined',"COLOR_BORDER":'undefined',"COLOR_TITLE":'undefined',"COLOR_SUBTITLE":'undefined',"COLOR_SECONDARY":'undefined',"COMMERCE_CODE":'qe1t43',"COMPANY_LOGIN_TITLE":'LEONELLAMARKET',"COMPANY_LOGO":'undefined',"COLOR_DARK":'undefined',"DEFAULT_AVATAR":'https://quipu-static.s3.amazonaws.com/asdcfvgred_image/asdcfvgred_2020202020202/LOGO_LEONELLA_512_X_512-removebg-preview71.png',"FORM_BACKGROUND":'https://quipu-static.s3.amazonaws.com/asdcfvgred_image/asdcfvgred_2020202020202/BANNER-REGISTRO54.png',"PRODUCTS_URL":'https://cm-products.apprunn.net',"API_GOOGLE_MAPS":'undefined',"REDIRECT_URI":'https://leonellamarket.com/login',"ROLE_CODE":'ROLEBASIC',"S3_IMAGES_URL":'//apprunn.s3.amazonaws.com',"SALES_URL":'https://cm-sales.apprunn.net',"STORAGE_USER_KEY":"ecommerce","TOKEN":'$2a$10$uyI2_vBOs6xmZYWLmA4rRuol8Ng0c5e_v97cHml57ai7hGx45pbdW',"UPLOAD_URL":'https://production.apprunn.net',"VISA_MERCHAN_ID":'undefined',"WAREHOUSE_ADDRESS":'undefined',"WAREHOUSE_ID":'undefined',"WAREHOUSE_NAME":'undefined',"BANNER_SEARCHER_SHOW":'undefined',"WAYS_DELIVERIES":'undefined',"GOOGLE_MAP_API_KEY":'undefined',"URL_VALID_DOCUMENT_NUMBER":'undefined',"PAYMENTEZ_CLIENT":'undefined',"PAYMENTEZ_KEY":'undefined',"SALES_URL_HTTP2":'undefined',"NO_ICON_CATEGORY":'true',"PAGE_DESCRIPTION":'undefined',"PAGE_KEYWORD":'undefined',"PAGE_TITLE":'LEONELLAMARKET',"PRODUCTS_READ_REPORT":'https://cm-products.apprunn.net',"SALES_READ_REPORT":'https://cm-sales.apprunn.net',"USER_LOCKED":'undefined'}).BUILD === 'web' ? __webpack_require__(832).withParams : __webpack_require__(279).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(818);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


function sendValue(val) {
	this.$emit('input', val);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'text-area',
	inheritAttrs: false,
	methods: {
		sendValue: sendValue
	},
	props: {
		value: null
	}
});

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_area_vue__ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4ca5ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_area_vue__ = __webpack_require__(939);
function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e4ca5ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_area_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4ca5ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_area_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(784)("cdbe054a", content, true, {});

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(783)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Avenir Next Regular;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Regular\"),url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Italic\"),url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light\"),url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Ultra Light Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Ultra Light Italic\"),url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Condensed\"),url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Medium Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Medium Italic\"),url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Demi Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Demi Italic\"),url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Bold;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Bold\"),url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy\"),url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Heavy Italic;font-style:normal;font-weight:400;src:local(\"Avenir Next LT Pro Heavy Italic\"),url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\")}@font-face{font-family:Avenir Next Book;font-style:normal;font-weight:400;src:local(\"Avenir Next Book\",url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"))}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/inputs/text-area.vue"],"names":[],"mappings":"AACA,WACE,gCAAmC,AACnC,kBAAmB,AACnB,gBAAoB,AACpB,wGAA2G,CAC5G,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,0GAA6G,CAC9G,AACD,WACE,2CAA8C,AAC9C,kBAAmB,AACnB,gBAAoB,AACpB,mHAAsH,CACvH,AACD,WACE,+BAAkC,AAClC,kBAAmB,AACnB,gBAAoB,AACpB,kHAAqH,CACtH,AACD,WACE,sCAAyC,AACzC,kBAAmB,AACnB,gBAAoB,AACpB,+GAAkH,CACnH,AACD,WACE,oCAAuC,AACvC,kBAAmB,AACnB,gBAAoB,AACpB,2GAA8G,CAC/G,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kGAAqG,CACtG,AACD,WACE,8BAAiC,AACjC,kBAAmB,AACnB,gBAAoB,AACpB,mGAAsG,CACvG,AACD,WACE,qCAAwC,AACxC,kBAAmB,AACnB,gBAAoB,AACpB,6GAAgH,CACjH,AACD,WACE,6BAAgC,AAChC,kBAAmB,AACnB,gBAAoB,AACpB,kFAAqF,CACtF","file":"text-area.vue","sourcesContent":["\n@font-face {\n  font-family: \"Avenir Next Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Regular\"), url(\"/static/fonts/AvenirNextLTPro-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Italic\"), url(\"/static/fonts/AvenirNextLTPro-It.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light\"), url(\"/static/fonts/AvenirNextLTPro-UltLt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Ultra Light Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Ultra Light Italic\"), url(\"/static/fonts/AvenirNextLTPro-UltLtIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Condensed\"), url(\"/static/fonts/AvenirNextLTPro-MediumCn.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Medium Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Medium Italic\"), url(\"/static/fonts/AvenirNextLTPro-MediumIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Demi Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Demi Italic\"), url(\"/static/fonts/AvenirNextLTPro-DemiIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Bold\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Bold\"), url(\"/static/fonts/AvenirNextLTPro-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy\"), url(\"/static/fonts/avenir-heavy-webfont.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Heavy Italic\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next LT Pro Heavy Italic\"), url(\"/static/fonts/AvenirNextLTPro-HeavyIt.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Avenir Next Book\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Avenir Next Book\", url(\"/static/fonts/Avenir-book.woff\") format(\"woff\"));\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._b({staticClass:"text-area",attrs:{"outline":"","hide-details":"","value":_vm.value},on:{"input":_vm.sendValue}},'v-textarea',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.1460178d547da0805f52.js